<app-page>
  <ng-template #headerTpl>
    <app-header>
      <ng-template #headerContent>
        <app-room-filters [unavailableDates]="unavailableDates" [noAvailability]="noAvailability" [isInHeader]="true" [hostel]="hostel"></app-room-filters>
      </ng-template>
    </app-header>

  </ng-template>

  <ng-template #mainTpl>
    <div class="container">
      <div class="content">

        <app-hostel-image-carousel [hostel]="hostel"></app-hostel-image-carousel>

        <app-hostel-details (anchorClicked)="scrollToAnchor($event)" [hostel]="hostel" [ngClass]="{'skeleton': !hostel}"></app-hostel-details>

        <!-- <ng-container *ngIf="hydratedness === HOSTEL_HYDRATION_LEVEL.FULL"> -->
          <app-hostel-badges (anchorClicked)="scrollToAnchor($event)" [hostel]="hostel" (showDialog)="open()"></app-hostel-badges>
        <!-- </ng-container> -->

        <app-hostel-image-grid [hostel]="hostel" [ngClass]="{'skeleton': !hostel}"></app-hostel-image-grid>

        <div class="spacer"></div>

        <app-hostel-description [hostel]="hostel" (cardClicked)="open()" [ngClass]="{'skeleton': !hostel}"></app-hostel-description>

        <div class="spacer-view-more" id="availability"></div>

        <app-room-filters [unavailableDates]="unavailableDates" [noAvailability]="noAvailability" [hostel]="hostel"></app-room-filters>

        <!-- todo make a component -->
          <div class="rooms-booking">
            <div class="rooms flex row">
              <app-room-list [isLoading]="roomsLoading" [rooms]="rooms" [hostel]="hostel"></app-room-list>
            </div>

            <div class="booking">
              <app-booking-widget class="booking-sticky" [hostel]="hostel"></app-booking-widget>
            </div>
          </div>

        <ng-container *ngIf="rooms">
          <div class="spacer"></div>
        </ng-container>

        <app-reviews [hostel]="hostel"></app-reviews>
        <div class="spacer"></div>

        <div class="map_subheader font-secondary" style="margin-bottom: 1.25rem;">
          Where you'll be staying
        </div>

        <div class="map-container">
          <ng-container *ngIf="isBrowser">
            @defer {
              <ng-template #mapContainer></ng-template>
            }
            </ng-container>
        </div>

        <div class="spacer"></div>

        <app-hostel-description-mobile [hostel]="hostel"></app-hostel-description-mobile>

        <app-amenities [hostel]="hostel"></app-amenities>

        <app-reviews-mobile [hostel]="hostel"></app-reviews-mobile>

        <ng-container *ngIf="hostel?.recommendationsFromBackpackers">
          <app-recommendations [hostel]="hostel"></app-recommendations>
        </ng-container>

        <div class="spacer"></div>

        <app-contact-hostel [hostel]="hostel"></app-contact-hostel>
        
        <app-hostel-travel-guide [hostel]="hostel"></app-hostel-travel-guide>
      </div>
    </div>

    <!--todo move to separate component-->
    <ng-container *ngIf="showDialog">
      <app-qr-code-dialog (closeDialog)="showDialog = false;"></app-qr-code-dialog>
    </ng-container>

    <ng-container *ngIf="isBrowser">
      <ng-container *ngIf="!bottomSheetOpen">
        <app-hostel-footer
          [hostel]="hostel"
          [checkInDate]="checkInDate"
          [checkOutDate]="checkOutDate"
          (openBottomSheet)="openBottomSheet()">
        </app-hostel-footer>
      </ng-container>

      <ng-container *ngIf="bottomSheetOpen">
        <app-when-mobile-scroll
          [unavailableDates]="unavailableDates" [noAvailability]="noAvailability"
          (close)="closeBottomSheet()">
        </app-when-mobile-scroll>
      </ng-container>
    </ng-container>

  </ng-template>
</app-page>


